import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type {
	CreateInvoiceResponseType,
	CreateReversalInvoiceData,
	Invoice,
	InvoiceIndexData,
} from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";
import type { Order } from "~/modules/project/api/order/orderTypes.ts";

export function indexProcessedInvoices(): AxiosApiResponsePromise<InvoiceIndexData[]> {
	return axiosApi.get(`/invoices`);
}

export function indexProjectsInvoices(projectId: string): AxiosApiResponsePromise<Invoice[]> {
	return axiosApi.get(`projects/${projectId}/invoices`);
}


export function showInvoice({ invoiceId }: { invoiceId: string }): AxiosApiResponsePromise<Invoice> {
	return axiosApi.get(`/invoices/${invoiceId}`);
}

export function updateInvoiceSentAndPaidDetails({ invoiceId, updateData }: {
	invoiceId: string,
	updateData: {
		invoicePaidAt: string | null,
		invoiceSentAt: string | null,
		recipientInformation: string | null,
	}
}): AxiosApiResponsePromise<Invoice> {
	return axiosApi.patch(`/invoices/${invoiceId}/sent-and-paid-details`, updateData);
}

export function updateInvoiceTotals({ invoiceId, updateData }: {
	invoiceId: string,
	updateData: {
		subtotalCents: number;
		travelCostCentsBeforeVat: number;
		vatPercentage: number;
	}
}): AxiosApiResponsePromise<Invoice> {
	return axiosApi.patch(`/invoices/${invoiceId}/totals`, updateData);
}

export function assignOrderToInvoice(invoiceId: string, orderId: string): AxiosApiResponsePromise<{
	assignedOrderIds: string[];
}> {
	return axiosApi.post(`/invoices/${invoiceId}/order/${orderId}`);
}

export function getAssignableOrdersForInvoice(invoiceId: string): AxiosApiResponsePromise<Order[]> {
	return axiosApi.get(`/invoices/${invoiceId}/assignable-orders`);
}

export function generateInvoiceFile(invoiceId: string): AxiosApiResponsePromise<CreateInvoiceResponseType> {
	return axiosApi.post(`/invoices/${invoiceId}/invoice-document`, { invoiceId });
}

export function createReversalInvoice(data: CreateReversalInvoiceData): AxiosApiResponsePromise<{
	reversalInvoiceId: string;
}> {
	return axiosApi.post(`/invoices/reversal`, data);
}

export function deleteInvoice(invoiceId: string): AxiosApiResponsePromise<void> {
	return axiosApi.delete(`/invoices/${invoiceId}`);
}
